import { render } from "./DiagramPage.vue?vue&type=template&id=6be57154"
import script from "./DiagramPage.vue?vue&type=script&lang=js"
export * from "./DiagramPage.vue?vue&type=script&lang=js"

import "./DiagramPage.vue?vue&type=style&index=0&id=6be57154&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__